"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Div_1 = __importDefault(require("../Div"));
var Text_1 = __importDefault(require("../Text/Text"));
var commonScaleNumberStyles = {
    zIndex: 3
};
var ScaleLabelStyles = {
    fontFamily: 'Skatta Sans Black',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    borderRadius: 10,
    padding: 4
};
var generateScaleNumberContainerStyles = function (itemsCount, useAsImage) {
    if (useAsImage) {
        if (itemsCount === 1) {
            return __assign(__assign({}, commonScaleNumberStyles), { transform: 'scale(2)' });
        }
        else if (itemsCount === 2) {
            return __assign(__assign({}, commonScaleNumberStyles), { transform: 'scale(1.7)' });
        }
        else if (itemsCount < 5) {
            return __assign(__assign({}, commonScaleNumberStyles), { transform: 'scale(1.2)', position: 'absolute', bottom: '15%', left: '5%' });
        }
        return __assign(__assign({}, commonScaleNumberStyles), { position: 'absolute', bottom: '10%', left: '5%' });
    }
    if (itemsCount === 1) {
        return __assign(__assign({}, commonScaleNumberStyles), { transform: 'scale(2)', position: 'absolute', bottom: '15%', left: '10%' });
    }
    else if (itemsCount === 2) {
        return __assign(__assign({}, commonScaleNumberStyles), { transform: 'scale(1.5)', position: 'absolute', bottom: '12%', left: '10%' });
    }
    else if (itemsCount === 3 || itemsCount === 4) {
        return __assign(__assign({}, commonScaleNumberStyles), { transform: 'scale(1.1)', position: 'absolute', bottom: '15%', left: '5%' });
    }
    else if (itemsCount === 5 || itemsCount === 6) {
        return __assign(__assign({}, commonScaleNumberStyles), { position: 'absolute', bottom: '10%', left: '5%' });
    }
    else if (itemsCount === 7 || itemsCount === 8) {
        return __assign(__assign({}, commonScaleNumberStyles), { transform: 'scale(0.8)', position: 'absolute', bottom: '5%', left: '5%' });
    }
    return __assign(__assign({}, commonScaleNumberStyles), { position: 'absolute', bottom: '10%', left: '5%' });
};
var ScaleNumber = function (_a) {
    var styles = _a.styles, scaleNumber = _a.scaleNumber, itemsCount = _a.itemsCount, useAsImage = _a.useAsImage, label = _a.label;
    return (react_1.default.createElement(react_1.Fragment, null, scaleNumber && (react_1.default.createElement(Div_1.default, { id: 'scale-number', styles: generateScaleNumberContainerStyles(itemsCount, useAsImage) },
        react_1.default.createElement(Text_1.default, { id: 'scale-number-text', styles: styles, value: "".concat(scaleNumber) }),
        react_1.default.createElement("div", { style: ScaleLabelStyles }, label ? label : 'VAAKANUMERO')))));
};
exports.default = ScaleNumber;
//# sourceMappingURL=ScaleNumber.js.map